import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { ContactMessageResponse } from "./contracts/ContactMessageResponse";
import {
  deleteContactMessage,
  fetchContactMessages,
  markContactMessageRead,
} from "./slice-extensions/contact-messages-slice-extension";

type RequestStatus = "idle" | "loading" | "succeeded" | "failed";

interface ContactMessagesState {
  items: ContactMessageResponse[];
  totalCount: number;
  page: number;
  totalPages: number;
  listStatus: RequestStatus;
}

const initialState: ContactMessagesState = {
  items: [],
  totalCount: 0,
  page: 1,
  totalPages: 0,
  listStatus: "idle",
};

const contactMessagesSlice = createSlice({
  name: "contactMessages",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchContactMessages.pending, (state) => {
        state.listStatus = "loading";
      })
      .addCase(fetchContactMessages.fulfilled, (state, action) => {
        state.listStatus = "succeeded";
        state.items = action.payload.items;
        state.totalCount = action.payload.totalCount;
        state.page = action.payload.page;
        state.totalPages = action.payload.totalPages;
      })
      .addCase(fetchContactMessages.rejected, (state) => {
        state.listStatus = "failed";
      })
      .addCase(markContactMessageRead.fulfilled, (state, action) => {
        state.items = state.items.map((item) =>
          item.id === action.payload.id ? action.payload : item,
        );
      })
      .addCase(deleteContactMessage.fulfilled, (state, action) => {
        state.items = state.items.filter((item) => item.id !== action.payload);
        state.totalCount = Math.max(0, state.totalCount - 1);
      });
  },
});

export const selectContactMessages = (state: RootState) => state.contactMessages.items;
export const selectContactMessagesTotalCount = (state: RootState) =>
  state.contactMessages.totalCount;
export const selectContactMessagesListStatus = (state: RootState) =>
  state.contactMessages.listStatus;

export default contactMessagesSlice.reducer;
